import env from '#shared/config/env.js';

/**
 * Get wire transfer list of supported countries with EUR currency
 * @param {object[]} countryList - list of all available countries
 * @returns {object[]}
 */
const getWireTransferCountries = (countryList) => {
	if (!Array.isArray(countryList)) {
		return [];
	}
	// Filter WT countries which support EURos
	const wtEuroCountryList = env.wireTransferCountries
		.filter((country) => country.currency.includes('EUR'))
		.map((country) => country.value);
	// Get WT country list
	return countryList
		.filter((country) => wtEuroCountryList.includes(country.value));
};

export default getWireTransferCountries;
